import React, { useCallback } from 'react'
import SwiperButton from 'Components/swiper-button'

interface IProps {
  titleElement: JSX.Element
  titleObj: { link: string; label: string }
  navList?: { link: string; label: string; icon?: string; className?: string }[]
  more?: string
  onTitleClick?: () => void
  onNavItemClick: (item: any) => void
  slider?: {
    cur: number
    total: number
    onSlide?: (action: 'next' | 'prev') => any
    prevRef?: any
    nextRef?: any
  }
  className?: string
}

const FloorTitle: React.FC<any> = React.forwardRef((props, ref) => {
  const {
    titleElement,
    titleObj,
    navList = [],
    more,
    slider,
    onTitleClick,
    onNavItemClick,
    className = '',
  }: IProps = props

  const handleNext = useCallback(() => {
    if (typeof slider?.onSlide === 'function') {
      slider.onSlide('next')
    }
  }, [slider?.onSlide])

  const handlePrev = useCallback(() => {
    if (typeof slider?.onSlide === 'function') {
      slider.onSlide('prev')
    }
  }, [slider?.onSlide])

  return (
    <div className={`floor-title ${className}`}>
      {titleElement && (
        <div className="title" onClick={onTitleClick}>
          {titleElement}
        </div>
      )}
      {titleObj && titleObj?.link && (
        <a
          onClick={onTitleClick}
          className="title g-active-link-text"
          href={titleObj?.link}
          target={'_blank'}
        >
          {titleObj?.label}
        </a>
      )}
      {titleObj && !titleObj?.link && (
        <span onClick={onTitleClick} className="title">
          {titleObj?.label}
        </span>
      )}
      <div className="nav-wrap">
        {navList?.length > 0 &&
          navList?.map((item, index) => {
            return (
              <div className={`nav-item ${item?.className ?? ''}`} key={index}>
                <a
                  onClick={() => onNavItemClick && onNavItemClick(item)}
                  href={item.link}
                  target={'_blank'}
                  className="label-wrap"
                >
                  {item.icon && (
                    <img
                      src={item.icon}
                      style={{ width: 24, height: 24 }}
                      className="icon"
                    />
                  )}
                  <span className="label">{item.label}</span>
                </a>
              </div>
            )
          })}
        {more && (
          <a
            onClick={() =>
              onNavItemClick && onNavItemClick({ id: 'more', label: '更多' })
            }
            href={more}
            className="nav-item nav-more g-active-link-text"
            target={'_blank'}
          >
            更多
          </a>
        )}
      </div>
      {slider && (
        <div className="slider-action">
          <SwiperButton
            ref={(ref as any)?.prevRef}
            type="prev"
            buttonStyle={{
              position: 'absolute',
              right: '40px',
            }}
          />
          <SwiperButton
            type="next"
            ref={(ref as any)?.nextRef}
            buttonStyle={{
              position: 'absolute',
              right: '10px',
            }}
          />
        </div>
      )}
      <style jsx>
        {`
          .floor-title {
            display: flex;
            width: 100%;
            align-items: center;
          }
          .title {
            font-family: PingFangSC;
            font-size: 20px;
            font-weight: 600;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #1f2129;
          }
          .nav-wrap {
            margin-left: 8px;
            flex: 1;
            display: flex;
          }
          .nav-item {
            padding: 0 8px;
            height: 20px;
            font-family: PingFangSC;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #606370;
            border-right: 0.5px solid #979aa8;
          }
          .nav-item:last-child {
            border-right: none;
          }
          .label-wrap {
            display: flex;
            align-items: center;
          }
          .nav-more {
            position: relative;
            top: 0px;
          }
          .nav-more:after {
            content: '';
            width: 0;
            height: 0;
            margin-left: 3px;
            display: inline-block;
            position: relative;
            top: -1px;
            border-top: 3px solid transparent;
            border-bottom: 3px solid transparent;
            border-left: 5px solid #606370;
            vertical-align: middle;
          }
          .slier {
            line-height: 0;
            vertical-align: middle;
          }
          .slider-num {
            font-family: PingFangSC;
            font-size: 14px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: normal;
            letter-spacing: normal;
            color: #1f2129;
          }
          .slider-btn {
            display: inline-block;
            width: 22px;
            height: 22px;
            padding: 4px;
            border-radius: 4px;
            background-color: #e6e8f2;
          }
          .slider-action {
            position: relative;
            width: 100px;
            height: 34px;
          }
        `}
      </style>
    </div>
  )
})

export default FloorTitle
